/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_TitleInputs */

const en_settings_payments_title = /** @type {(inputs: Settings_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_settings_payments_title = /** @type {(inputs: Settings_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款记录`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Settings_Payments_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_title = /** @type {((inputs?: Settings_Payments_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_title(inputs)
	return zh_settings_payments_title(inputs)
});
export { settings_payments_title as "settings.payments.title" }